import React, { useEffect } from 'react';
import { Field } from 'formik';
import axios from 'axios';
import { getHeaders } from '../../../request/index';
import { SttAutocomplete } from '@stt-componentes/core';
import { REDE } from '../fieldNames';
import { MODALIDADE } from '../../../common/Constants';
import { useSignal, useSignalEffect } from '@preact/signals-react';

const Rede = ({ strings }) => {

    const carregarRedes = useSignal(false);
    const redes = useSignal([]);

    useEffect(() => {
        carregarRedes.value = true;
    }, []);

    useSignalEffect(() => {
        if (carregarRedes.value) {
            axios
                .get(`${global.gConfig.url_base_utilitarios}/rede?modalidade=${MODALIDADE.SIGLA}`, {headers: getHeaders() })
                .then((response) => {
                    if (response.data) {
                        const { itens } = response.data.data;
                        redes.value = itens;
                    } else {
                        redes.value = [];
                    }
                })
                .catch((err) => console.log(err));
        }
    });

    return (
        <Field name={REDE}>
            {({
                field: { name, value, onBlur },
                form: { setFieldValue }
            }) => (
                <SttAutocomplete
                    inputprops={{
                        name: name,
                        label: strings.rede
                    }}
                    getOptionLabel={option => option?.descricao || ''}
                    getOptionSelected={(option, val) => option?.id === val?.id}
                    options={redes.value}
                    value={value}
                    onBlur={onBlur}
                    onChange={(e, item) => {
                        setFieldValue(REDE, item || null);
                    }}
                />
            )}
        </Field>
    );
};

export default Rede;
